module.exports = __webpack_public_path__ + "img/g8.78a5c1d5.jpg";